/* tslint:disable */
/* eslint-disable */
/**
 * API Docs
 * The API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { DeleteMailResponse } from '../model';
// @ts-ignore
import { GetMailResponse } from '../model';
// @ts-ignore
import { GetMailsResponse } from '../model';
// @ts-ignore
import { PostMailRequest } from '../model';
// @ts-ignore
import { PostMailResponse } from '../model';
// @ts-ignore
import { PutMailRequest } from '../model';
// @ts-ignore
import { PutMailResponse } from '../model';
/**
 * MailsApi - axios parameter creator
 * @export
 */
export const MailsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {PostMailRequest} postMailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMail: async (postMailRequest: PostMailRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postMailRequest' is not null or undefined
            assertParamExists('createMail', 'postMailRequest', postMailRequest)
            const localVarPath = `/api/mails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postMailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMail: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteMail', 'id', id)
            const localVarPath = `/api/mails/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMail: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMail', 'id', id)
            const localVarPath = `/api/mails/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} limit 
         * @param {number} page 
         * @param {string} orderBy 
         * @param {string} orderDesc 
         * @param {string} [keyword] 
         * @param {string} [locationId] 
         * @param {string} [notificationType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailsByKeyword: async (limit: number, page: number, orderBy: string, orderDesc: string, keyword?: string, locationId?: string, notificationType?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getMailsByKeyword', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getMailsByKeyword', 'page', page)
            // verify required parameter 'orderBy' is not null or undefined
            assertParamExists('getMailsByKeyword', 'orderBy', orderBy)
            // verify required parameter 'orderDesc' is not null or undefined
            assertParamExists('getMailsByKeyword', 'orderDesc', orderDesc)
            const localVarPath = `/api/mails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }

            if (notificationType !== undefined) {
                localVarQueryParameter['notificationType'] = notificationType;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (orderDesc !== undefined) {
                localVarQueryParameter['orderDesc'] = orderDesc;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {PutMailRequest} putMailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMail: async (id: string, putMailRequest: PutMailRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateMail', 'id', id)
            // verify required parameter 'putMailRequest' is not null or undefined
            assertParamExists('updateMail', 'putMailRequest', putMailRequest)
            const localVarPath = `/api/mails/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putMailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MailsApi - functional programming interface
 * @export
 */
export const MailsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MailsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {PostMailRequest} postMailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMail(postMailRequest: PostMailRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostMailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMail(postMailRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMail(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteMailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMail(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMail(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMail(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} limit 
         * @param {number} page 
         * @param {string} orderBy 
         * @param {string} orderDesc 
         * @param {string} [keyword] 
         * @param {string} [locationId] 
         * @param {string} [notificationType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMailsByKeyword(limit: number, page: number, orderBy: string, orderDesc: string, keyword?: string, locationId?: string, notificationType?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMailsByKeyword(limit, page, orderBy, orderDesc, keyword, locationId, notificationType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {PutMailRequest} putMailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMail(id: string, putMailRequest: PutMailRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutMailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMail(id, putMailRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MailsApi - factory interface
 * @export
 */
export const MailsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MailsApiFp(configuration)
    return {
        /**
         * 
         * @param {PostMailRequest} postMailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMail(postMailRequest: PostMailRequest, options?: any): AxiosPromise<PostMailResponse> {
            return localVarFp.createMail(postMailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMail(id: string, options?: any): AxiosPromise<DeleteMailResponse> {
            return localVarFp.deleteMail(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMail(id: string, options?: any): AxiosPromise<GetMailResponse> {
            return localVarFp.getMail(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} limit 
         * @param {number} page 
         * @param {string} orderBy 
         * @param {string} orderDesc 
         * @param {string} [keyword] 
         * @param {string} [locationId] 
         * @param {string} [notificationType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMailsByKeyword(limit: number, page: number, orderBy: string, orderDesc: string, keyword?: string, locationId?: string, notificationType?: string, options?: any): AxiosPromise<GetMailsResponse> {
            return localVarFp.getMailsByKeyword(limit, page, orderBy, orderDesc, keyword, locationId, notificationType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {PutMailRequest} putMailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMail(id: string, putMailRequest: PutMailRequest, options?: any): AxiosPromise<PutMailResponse> {
            return localVarFp.updateMail(id, putMailRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createMail operation in MailsApi.
 * @export
 * @interface MailsApiCreateMailRequest
 */
export interface MailsApiCreateMailRequest {
    /**
     * 
     * @type {PostMailRequest}
     * @memberof MailsApiCreateMail
     */
    readonly postMailRequest: PostMailRequest
}

/**
 * Request parameters for deleteMail operation in MailsApi.
 * @export
 * @interface MailsApiDeleteMailRequest
 */
export interface MailsApiDeleteMailRequest {
    /**
     * 
     * @type {string}
     * @memberof MailsApiDeleteMail
     */
    readonly id: string
}

/**
 * Request parameters for getMail operation in MailsApi.
 * @export
 * @interface MailsApiGetMailRequest
 */
export interface MailsApiGetMailRequest {
    /**
     * 
     * @type {string}
     * @memberof MailsApiGetMail
     */
    readonly id: string
}

/**
 * Request parameters for getMailsByKeyword operation in MailsApi.
 * @export
 * @interface MailsApiGetMailsByKeywordRequest
 */
export interface MailsApiGetMailsByKeywordRequest {
    /**
     * 
     * @type {number}
     * @memberof MailsApiGetMailsByKeyword
     */
    readonly limit: number

    /**
     * 
     * @type {number}
     * @memberof MailsApiGetMailsByKeyword
     */
    readonly page: number

    /**
     * 
     * @type {string}
     * @memberof MailsApiGetMailsByKeyword
     */
    readonly orderBy: string

    /**
     * 
     * @type {string}
     * @memberof MailsApiGetMailsByKeyword
     */
    readonly orderDesc: string

    /**
     * 
     * @type {string}
     * @memberof MailsApiGetMailsByKeyword
     */
    readonly keyword?: string

    /**
     * 
     * @type {string}
     * @memberof MailsApiGetMailsByKeyword
     */
    readonly locationId?: string

    /**
     * 
     * @type {string}
     * @memberof MailsApiGetMailsByKeyword
     */
    readonly notificationType?: string
}

/**
 * Request parameters for updateMail operation in MailsApi.
 * @export
 * @interface MailsApiUpdateMailRequest
 */
export interface MailsApiUpdateMailRequest {
    /**
     * 
     * @type {string}
     * @memberof MailsApiUpdateMail
     */
    readonly id: string

    /**
     * 
     * @type {PutMailRequest}
     * @memberof MailsApiUpdateMail
     */
    readonly putMailRequest: PutMailRequest
}

/**
 * MailsApi - object-oriented interface
 * @export
 * @class MailsApi
 * @extends {BaseAPI}
 */
export class MailsApi extends BaseAPI {
    /**
     * 
     * @param {MailsApiCreateMailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailsApi
     */
    public createMail(requestParameters: MailsApiCreateMailRequest, options?: AxiosRequestConfig) {
        return MailsApiFp(this.configuration).createMail(requestParameters.postMailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MailsApiDeleteMailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailsApi
     */
    public deleteMail(requestParameters: MailsApiDeleteMailRequest, options?: AxiosRequestConfig) {
        return MailsApiFp(this.configuration).deleteMail(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MailsApiGetMailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailsApi
     */
    public getMail(requestParameters: MailsApiGetMailRequest, options?: AxiosRequestConfig) {
        return MailsApiFp(this.configuration).getMail(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MailsApiGetMailsByKeywordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailsApi
     */
    public getMailsByKeyword(requestParameters: MailsApiGetMailsByKeywordRequest, options?: AxiosRequestConfig) {
        return MailsApiFp(this.configuration).getMailsByKeyword(requestParameters.limit, requestParameters.page, requestParameters.orderBy, requestParameters.orderDesc, requestParameters.keyword, requestParameters.locationId, requestParameters.notificationType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MailsApiUpdateMailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailsApi
     */
    public updateMail(requestParameters: MailsApiUpdateMailRequest, options?: AxiosRequestConfig) {
        return MailsApiFp(this.configuration).updateMail(requestParameters.id, requestParameters.putMailRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
